import type * as ProjectPageViewTypes from '../../state/views/projectPage/types';
import {
  EMPTY_PANEL_BANK_CONFIG,
  EMPTY_PANEL_BANK_SECTION_CONFIG_FOR_REPORT,
} from '../../util/panelbankConfigs';
import * as Section from '../../util/section';
import {getLinePlotTemplateValues} from '../WorkspaceTemplate/runLinePlots/useLinePlotSections';
import {getWorkspaceLayoutTemplateValues} from '../WorkspaceTemplate/workspaceLayout/useWorkspaceLayoutSections';
import {type WorkspaceTemplate} from '../WorkspaceTemplate/workspaceTemplatesQueries';

const DEFAULT_CONFIG: Section.Config = {
  openRunSet: 0,
  runSets: [Section.emptyRunSetSelectAll()],
  panelBankConfig: EMPTY_PANEL_BANK_CONFIG,
  panelBankSectionConfig: EMPTY_PANEL_BANK_SECTION_CONFIG_FOR_REPORT,
  customRunColors: {},
  workspaceSettings: {},
};

// Sweep, Group and Project workspaces are exactly the same
// currently.
const DEFAULT_MULTI_RUN_VIEW_SPEC: ProjectPageViewTypes.ProjectPageViewSpec = {
  vizExpanded: false,
  libraryExpanded: true,
  section: DEFAULT_CONFIG,
};

export const createMultiRunDefaultSpec = (
  workspaceTemplate: WorkspaceTemplate | undefined
): ProjectPageViewTypes.ProjectPageViewSpec => {
  return {
    ...DEFAULT_MULTI_RUN_VIEW_SPEC,
    section: {
      ...DEFAULT_CONFIG,
      workspaceSettings: {
        linePlot: {
          ...getLinePlotTemplateValues(workspaceTemplate),
        },
        ...getWorkspaceLayoutTemplateValues(workspaceTemplate),
      },
    },
  };
};
